var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"userPreference-parkingTime"}},[_c('ul',_vm._l((_vm.list),function(item){return _c('li',{key:item.timePoint},[_c('span',[_vm._v(_vm._s(item.timePoint))]),_c('el-progress',{attrs:{"percentage":item.value,"stroke-width":_vm.strokeWidth}})],1)}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }